// extracted by mini-css-extract-plugin
export default {"popconfirm-title":"popConfirm_popconfirm-title__iKW8h","popconfirm-description":"popConfirm_popconfirm-description__YCIhd","footer-buttons":"popConfirm_footer-buttons__SC8b8"};